var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((this.footerInfo),function(info){return _c('div',{key:info.id},[_c('FooterInfo',{attrs:{"footerInfo":info,"infoType":"dataprotection"}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }